exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper[data-v-8425f1fa]{width:100%;padding:25px 10%\n}\n@media(max-width: 1200px){\n.form-wrapper[data-v-8425f1fa]{padding:10px .5%;margin-left:0\n}\n}\n.form-wrapper .md-layout[data-v-8425f1fa]{margin-bottom:5px\n}\n.form-wrapper-frame[data-v-8425f1fa]{width:100%;padding:25px;margin-bottom:15px\n}\n.title-icon[data-v-8425f1fa]{margin-top:-5px\n}\n.switch-label[data-v-8425f1fa]{margin-top:-4px\n}\n.switch-label .md-icon[data-v-8425f1fa]{margin-right:5px\n}\n.md-select-value[data-v-8425f1fa]{white-space:normal\n}\n#submit-btn[data-v-8425f1fa]{margin:25px 0;width:33%;padding:6px;font-size:1.1em\n}\n#window-title[data-v-8425f1fa],#geo-title[data-v-8425f1fa]{margin-bottom:15px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-8425f1fa","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/license/LicenseForm.vue
// module id = 171
// module chunks = 0